module.exports = __webpack_public_path__ + "static/media/SvgPlus.5d1fa44d.svg";